import { useCallback } from 'react';
import { trackAnalytics, getTokenCount } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';
import { MESSAGE_DATA_ROLES } from 'common/components/CopyMagic/constants';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';

const useTrackSuggestionClicked = () => {
  const { productEvents } = useConfigContext();
  const { findMessagesBy } = useMessagesContext();

  const trackCallback = useCallback(
    ({ suggestion, systemMessage }: { suggestion: string; systemMessage: string }) => {
      const trackProductAnalytics = trackAnalytics(productEvents);

      trackProductAnalytics('Suggestion Clicked', {
        'User Messages Count': findMessagesBy({ role: MESSAGE_DATA_ROLES.USER }).length,
        'Suggestion Name': suggestion,
        'Tokens Sent': getTokenCount(suggestion) + getTokenCount(systemMessage),
      });
    },
    [productEvents, findMessagesBy],
  );

  return trackCallback;
};

export default useTrackSuggestionClicked;
